<script setup lang="ts">
const isOpenAnswer = ref<number>(-1)

const questions = [
  {
    question: 'برای انجام تبادل ارز در پی جیب از کجا شروع کنیم؟',
    answer:
      'ابتدا باید در پی جیب ثبت نام کرده سپس می توانید برای شروع تبادل ارز نسبت به ثبت درخواست فروش و یا خرید با نرخ مورد نظر خود اقدام کنید و یا روی درخواست های خرید و فروش موجود روی سایت که توسط کاربران دیگر ثبت شده است پیشنهاد بگذارید.',
  },
  {
    question: 'درخواست خرید و یا فروش دقیقا به چه معنا است؟',
    answer:
      'درخواست فروش یعنی ارز در حسابی بانکی در اروپا،استرالیا، کانادا و یا ترکیه دارم و می خواهم معادل ریالی آن را در حسابی در ایران دریافت کنم - درخواست خرید یعنی ریال در حسابی بانکی در ایران دارم و می خواهم معادل ارزی آن را در حسابی در بانک های اروپا، استرالیا، کانادا و یا ترکیه دریافت کنم.',
  },
  {
    question: 'نرخ تبدیل ارز توسط چه کسی مشخص می شود؟',
    answer:
      'نرخ تبادل ارز در پی جیب به صورت توافقی بین خریدار و فروشنده تعیین می شود و پلتفرم پی جیب هیچ دخالتی در نرخ گذاری برای طرفین ندارد.',
  },
  {
    question: 'انجام تبادل ارز در پلتفرم پی جیب چقدر زمان می برد؟',
    answer:
      'در زمان ثبت درخواست های فروش، خرید و یا پیشنهاد روی درخواست های موجود هر چه نرخ تبدیل پیشنهادی شما به نرخ منصفانه بازار نزدیکتر باشد احتمال اینکه نرخ شما توسط سایر کاربران مورد قبول واقع شود بیشتر خواهد بود و در نتیجه با صرف زمان کمتری وارد انجام مراحل تراکنش خواهید شد.همچنین پارامترهایی چون کشور بانک های مبداء و مقصد، روزهای کاری در ایران و خارج کشور و یا نوع پرداخت ارز در مدت زمان انجام تراکنش تاثیر گذار است.',
  },
  {
    question: 'اگر فروشنده و یا خریدار در یکی از مراحل انجام تراکنش پس از تأیید اولیه، انصراف دهد چه اتفاقی می افتد؟',
    answer:
      'در راستای تضمین انجام موفق تراکنش ها، کاربران موظف به انجام تعهدات خود در قبال پلتفرم پی جیب و طرف مقابل هستند. در صورت عدم واریز ریال توسط خریدار و یا عدم واریز ارز توسط فروشنده در مدت زمان قابل قبول، پلتفرم پی جیب حق حذف اکانت پی جیب آن کاربر را دارد. در این موارد در صورت امکان تیم پشتیبانی پی جیب با هماهنگی طرف مقابل ،اقدام به جایگزینی فروشنده و یا خریدار جدید می کند تا تراکنش به طور کامل انجام شود و یا مبلغ واریزی خریدار به طور کامل به او عودت داده می شود.',
  },
  {
    question: 'آیا برای انجام تبادل ارز در پلتفرم پی جیب می توان از حساب های شرکتی در خارج از کشور استفاده کرد؟',
    answer:
      'خیر - با توجه به اینکه پلتفرم پی جیب به صورت جمعی و فرد به فرد برای نیاز های غیر تجاری طراحی شده است و به علت محدودیت های انتقال با حساب های شرکتی نمی توان از این حساب ها برای تبادل ارز در پی جیب استفاده کرد و تنها حساب های بانکی شخصی افراد در خارج از کشور مورد تأیید است.',
  },
  {
    question: 'چرا برای استفاده از پلتفرم پی جیب نیاز به احراز هویت با مدرک معتبر است؟',
    answer:
      'در پلتفرم پی‌جیب تلاش شده که تراکنش‌ها و تبادلات ارزی، بدون نگرانی و با امنیت کامل انجام شود و امکان هیچ سوءاستفاده‌ای در آن نباشد و به همین دلیل به منظور جلوگیری از ایجاد حساب‌های کاربری جعلی در پی‌جیب، مدارک شناسایی احراز هویت از کاربران دریافت می‌شود. این موضوع، به همه‌ی کاربران پی‌جیب کمک می‌کند که با اطمینان خاطر و در کمال آرامش تراکنش مورد نظر خود را انجام دهند. این اطمینان به تمامی کاربران داده می‌شود که مدارک شناسایی صرفاً در راستای احراز هویت و اطمینان از عدم سوءاستفاده دریافت می‌شود و هیچ کاربرد دیگری ندارد و تمامی اطلاعات کاربران نزد پی‌جیب محفوظ می‌ماند.',
  },
  {
    question: 'چرا تبادل ارز در پلتفرم پی جیب نسبت به روش های دیگر، شفاف و امن تر است؟',
    answer:
      'پی‌جیب بستری است که خریدار و فروشنده را به یکدیگر وصل می کند. این کار در پی‌جیب به صورتی امن و بر مبنای شفافیت انجام می‌شود. تیم پشتیبانی پی‌جیب در طی فرایند تبادل ارز، مرحله به مرحله با خریدار و فروشنده همراه است و تمامی تأییدیه‌ها و پرداخت‌ها را با طرفین تراکنش اعتبارسنجی می‌نماید تا تبادل به‌ صورت کامل و بدون اشکال، انجام شود. در روش‌های سنتی مرسوم، که تبادل ارز به صورت حضوری و یا در فضای مجازی ( تلگرام - فیسبوک و...) انجام می شود، احتمال انجام تخلفاتی مثل سرقت ارز و یا ارائه‌ی رسیدهای تقلبی واریزی و یا عدم واریز ارز یا ریال ، باعث نگرانی افرادی که به تبادل ارز نیاز دارند شده که پلتفرم پی‌جیب، این دغدغه را به خوبی پاسخ داده است.',
  },
  {
    question:
      'می‌خواهم در پی‌جیب پیشنهاد ثبت کنم، اما کشور مورد نظرم را در درخواست ها پیدا نمی کنم. چه کار می‌توانم بکنم؟',
    answer:
      'اگر کشور مورد نظر شما یکی از کشورهای اتحادیه‌ی اروپا باشد، نیازی نیست حتماً طرف مقابل تراکنش شما هم از همان کشور باشد. به عنوان مثال اگر کشور مورد نظر شما ایتالیا است، می‌توانید روی درخواست شخصی از هلند هم پیشنهاد بگذارید. گفتنی است که در حال حاضر پی‌جیب امکان تبادل ارز بین ایران و اروپا، استرالیا، کانادا و ترکیه را فراهم کرده است.',
  },
  {
    question: 'آیا می توانم با پلتفرم پی جیب هزینه های دانشجویی خود را پرداخت کنم؟',
    answer:
      'بله - در جال حاضر دانشجویان زیادی برای پرداخت هزینه های اولیه تحصیل یا مهاجرت خود از پلتفرم پی جیب استفاده می کنند. کافی است در پلتفرم پی جیب درخواست خرید با مبلغ مورد نظر خود ثبت کنید و در قسمت توضیحات درخواست عنوان شود که برای چه خدماتی و یا کدام دانشگاه می باشد. تیم پشتیبانی پی جیب در زمان پرداخت ارز توسط فروشنده هماهنگی های لازم را با شما و فروشنده انجام خواهد داد.',
  },
  {
    question: 'آیا امکان تبادل ارز به صورت حضوری و یا نقدی در پلتفرم پی جیب وجود دارد؟',
    answer:
      'خیر - پرداخت های ارزی فقط و فقط از طریق حواله های بین بانکی حساب ها در خارج از کشور و یا انتقال های آنلاین انجام می گیرد.',
  },
  {
    question: 'آیا امکان نقد کردن درآمد ارزی به صورت ریال در ایران با پلتفرم پی جیب وجود دارد؟',
    answer: 'بله - اینکار با ثبت یک درخواست فروش با مبلغ مورد نظر شما به راحتی امکان پذیر است.',
  },
]

const toggleAnswer = (index: number): void => {
  isOpenAnswer.value = isOpenAnswer.value === index ? -1 : index
}
</script>

<template>
    <!-- Questions Section -->
    <section id="questions" class="w-full py-8 lg:py-[96px] px-6 lg:px-24 bg-white">
        <BaseContainer>
            <div class="w-full flex flex-col items-center gap-[53px] ">
                <div class="flex flex-col items-center gap-2">
                    <h2 class="text-[#2626BF] font-bold text-lg lg:text-[40px] mb-4">سوالات متداول راجع به انتقال
                        ارز</h2>
                    <p class="text-[#0F1114] font-medium  text-[12px] lg:text-lg">در این بخش می‌توانید راهنمایی‌های
                        لازم
                        را
                        پیدا
                        کنید.</p>
                </div>

                <div class="w-full flex flex-col items-center">
                    <div v-for="(item, index) in questions" :key="index" class="w-full ">
                        <!-- Question -->
                        <button type="button"
                            class="cursor-pointer  border-[#F0F2F5] py-4 lg:py-6 px-6 flex gap-4 items-start lg:items-center"
                            :class="{ 'border-b-2': index !== isOpenAnswer }" @click="toggleAnswer(index)">
                            <img :class="[
                                'transition-transform duration-700 ease-in-out',
                                index === isOpenAnswer ? 'rotate-180' : 'rotate-0'
                            ]" :src="index === isOpenAnswer ? '/home/img/home/minus-cirlce.svg' : '/home/img/home/plus-add.svg'"
                                alt="" aria-hidden="true">

                            <span class="lg:text-[21px] font-semibold text-[#0F1114]"
                                :class="{ 'text-[#2E2EE5]': index === isOpenAnswer }">{{
                                    item.question }}</span>
                        </button>

                        <!-- Answer -->
                        <Transition name="fade-toggle">
                            <div v-show="index === isOpenAnswer"
                                class="border-b-2 border-[#F0F2F5] text-[#33373D] text-[14px] lg:text-[16px] pb-6 px-6">
                                <p class="text-[#0F1114] font-medium text-justify">{{ item.answer }}</p>
                            </div>
                        </Transition>

                    </div>
                </div>
            </div>
        </BaseContainer>
    </section>

</template>

<style scoped>
.fade-toggle-enter-active,
.fade-toggle-leave-active {
    transition: opacity 0.4s ease, 0.4s ease;
    overflow: hidden;
}

.fade-toggle-enter-from,
.fade-toggle-leave-to {
    opacity: 0;
}

.fade-toggle-enter-to,
.fade-toggle-leave-from {
    opacity: 1;
}
</style>
